import { useSearchParams } from "react-router-dom";
import { Stack, Typography } from "@altimateai/lego";
import { useAppState } from "@/modules/app/useAppContext";
import DiscoverPredefinedFilters from "./DiscoverPredefinedFilters";

const DiscoverHeader = () => {
  const { loggedinUser, isDatabricksTenant } = useAppState();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "opportunities";

  // The predefined quick filters target Snowflake opportunity types
  // (dormant tables, big-warehouse copies, remote spillage) — not relevant
  // on Databricks tenants.
  const showPredefinedFilters = tab === "opportunities" && !isDatabricksTenant;

  return (
    <>
      <Stack align="center" justify="between" className="al-mb-2">
        <Typography variant="page-heading">Discover</Typography>
      </Stack>
      {showPredefinedFilters && (
        <div className="al-w-full al-max-w-full al-py-3">
          <DiscoverPredefinedFilters currentUser={loggedinUser} />
        </div>
      )}
    </>
  );
};

export default DiscoverHeader;
